import { Component, OnInit } from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';

export interface Model {
  title: string;
  data: string;
}

@Component({
  selector: 'app-close-sessions',
  templateUrl: './close-sessions.component.html',
  styleUrls: ['./close-sessions.component.css', '../../myreports.component.css']
})
export class CloseSessionsComponent extends DialogComponent<Model, any> implements OnInit {

  title: string;
  data: any;
  closedSessions: any = [];
  totalSessions: number = 0;
  count: number = 0;
  currentUser: any;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.closedSessions = this.data.closedSessions;
    this.totalSessions = this.data.totalSessions;
    this.count = this.data.count;
    this.currentUser = this.data.currentUser;
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/close-sessions/close-sessions.component.ts